<app-widget-core>

  <div class="widget-item-gauge-chart">

    <div class="title-wrap">

      @if (icon) {
        <yu-icon [name]="icon"></yu-icon>
      }

      <div class="title">{{ title }}</div>

    </div>

    @if (data || data === 0) {

      <apx-chart
        [series]="[data]"
        [labels]="chartOptions.labels!"
        [fill]="chartOptions.fill!"
        [stroke]="chartOptions.stroke!"
        [colors]="[chartColor]"
        [plotOptions]="chartOptions.plotOptions!"
        [chart]="chartOptions.chart!"
      ></apx-chart>

      @if (percentage) {

        <div
          class="percentage data-chart"
          [ngClass]="[stateStats]"
        >
          <yu-icon [name]="iconStats"></yu-icon>
          <span>{{ percentage }}</span>
        </div>

      }

      @if (subData || subData === 0) {

        <div class="subdata-wrap">

          <div class="subdata">
            {{ subData | currency: 'EUR': 'symbol': '1.2-2': 'es' }}
          </div>

          <div
            class="percentage"
            [ngClass]="[subDataStateStats]"
          >
            <yu-icon [name]="subDataIconStats"></yu-icon>
            <span>{{ subDataPercentage }}</span>
          </div>

        </div>

      }

    } @else {

      <div class="no-data-chart">
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      </div>

    }

  </div>

</app-widget-core>
